
import { mapState, mapGetters } from "vuex";
import { format } from "date-fns";
import UiAccordion from "@/components/UI/UiAccordion.vue";
import UiAccordionItem from "@/components/UI/UiAccordionItem.vue";
// import UiCheckbox from "~/components/UI/UiCheckbox";
import OrderSummary from "@/components/pages/order/OrderSummary.vue";
import OrderProductList from "@/components/pages/order/OrderProductList.vue";
import UiButton from "@/components/UI/UiButton";
import { PAYMENT_STATUSES } from "@/config";
export default {
  name: "TrackingComponent",
  components: {
    UiAccordion,
    UiAccordionItem,
    // UiCheckbox,
    OrderSummary,
    OrderProductList,
    UiButton,
  },
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    hideCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notify: this.order.notify,
      orderStatusesOptions: {
        order_placed: 0,
        in_production: 2,
        in_transit: 3,
        delivered: 4,
        ready_to_ship: 5,
      },
      statusesOptions: {
        next: 0,
        in_progress: 1,
        completed: 2,
      },
      PAYMENT_STATUSES,
    };
  },
  computed: {
    ...mapState({
      settings: (state) => state.general.settings,
    }),
    ...mapGetters({
      getSystemDateFormat: "general/getSystemDateFormat",
      getOrderStatuses: "general/getOrderStatuses",
    }),
    statuses() {
      return JSON.parse(JSON.stringify(this.order))?.statuses?.sort(
        (a, b) => a.position - b.position
      );
    },
    statusesById() {
      return this.getOrderStatuses.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },
    mappedStatuses() {
      return this.statuses
        .filter(
          (el) => el.order_status !== this.orderStatusesOptions.ready_to_ship
        )
        .map((el) => {
          switch (el.order_status) {
            case this.orderStatusesOptions.order_placed: {
              return {
                ...el,
                date_to_show: this.formateDate(this.order.customer_date),
              };
            }
            case this.orderStatusesOptions.in_production: {
              if (el.status === this.statusesOptions.in_progress) {
                return {
                  ...el,
                  date_to_show: this.formateDate(el.started_at),
                };
              } else if (el.status === this.statusesOptions.completed) {
                return {
                  ...el,
                  date_to_show: this.formateDate(el.completed_at),
                };
              } else {
                return {
                  ...el,
                  date_to_show: "-",
                };
              }
            }
            case this.orderStatusesOptions.in_transit: {
              const inProgressStatus = this.statuses.find(
                (i) =>
                  i.order_status === this.orderStatusesOptions.in_production
              );
              if (
                inProgressStatus?.status === this.statusesOptions.in_progress ||
                (inProgressStatus?.status === this.statusesOptions.completed &&
                  !el.status)
              ) {
                return {
                  ...el,
                  date_to_show: `${this.$t("estimated")}: ${this.formateDate(
                    this.order.manufacturing_term || ""
                  )}`,
                };
              } else if (el.status === this.statusesOptions.in_progress) {
                return {
                  ...el,
                  date_to_show: this.formateDate(el.started_at),
                };
              } else if (el.status === this.statusesOptions.completed) {
                return {
                  ...el,
                  date_to_show: this.formateDate(el.completed_at),
                };
              } else {
                return {
                  ...el,
                  date_to_show: "-",
                };
              }
            }
            case this.orderStatusesOptions.delivered: {
              const inTransitStatus = this.statuses.find(
                (i) => i.order_status === this.orderStatusesOptions.in_transit
              );
              if (
                inTransitStatus?.status === this.statusesOptions.in_progress
              ) {
                return {
                  ...el,
                  date_to_show: `${this.$t("estimated")}: ${this.formateDate(
                    // inTransitStatus.started_at
                    this.order.ship_date
                  )}`,
                };
              } else {
                return {
                  ...el,
                  date_to_show:
                    el.status === this.statusesOptions.completed
                      ? this.formateDate(this.order.ship_date)
                      : `${this.$t("estimated")}: ${this.formateDate(
                          this.order.ship_date
                        )}`,
                };
              }
            }
            default: {
              return {
                ...el,
                date_to_show: `${this.$t("estimated")}: ${this.formateDate(
                  this.order.ship_date
                )}`,
              };
            }
          }
        });
    },
    formateDate() {
      return (date) => format(new Date(date), this.getSystemDateFormat);
    },
    unauthorizedPath() {
      return this.localePath({
        path: `/return/${this.order.id}`,
        query: {
          email: this.order.user_email || this.$route.query.email,
          billing_zip: this.$route.query.billing_zip,
        },
      });
    },
    hideRequestReturnButton() {
      const returnRequests = this.order.return_requests.flatMap(
        (request) => request.request_products
      );
      const totalOrderQty = this.order.order_products.reduce(
        (sum, product) => sum + (product.quantity || product.qty),
        0
      );
      const totalRequestsQty = returnRequests.reduce(
        (sum, req) => sum + (req.quantity || req.qty),
        0
      );
      const canBeReturnedByAmount = this.order.can_be_returned_by_amount;
      const canBeReturnedByTimeframe = this.order.order_products.some(
        (product) => product.can_be_returned_by_timeframe
      );

      return (
        this.$route.query.billing_zip &&
        totalOrderQty > totalRequestsQty &&
        canBeReturnedByAmount &&
        canBeReturnedByTimeframe
      );
    },
  },
};
